// eslint-disable-next-line @typescript-eslint/naming-convention
export const countryData = [
  {
    country: 'China',
    name: '中国',
    code_name: 'CN',
    areaCode: '86',
    name_zhTW: '中國',
  },
  {
    country: 'Hong Kong (China)',
    name: '中国香港',
    code_name: 'HK',
    areaCode: '852',
    name_zhTW: '中國香港',
  },
  {
    country: 'United States of America',
    name: '美国',
    code_name: 'US',
    areaCode: '1',
    name_zhTW: '美國',
  },
  {
    country: 'Singapore',
    name: '新加坡',
    code_name: 'SG',
    areaCode: '65',
    name_zhTW: '新加坡',
  },
  {
    country: 'Canada',
    name: '加拿大',
    code_name: 'CA',
    areaCode: '1',
    name_zhTW: '加拿大',
  },
  {
    country: 'Australia',
    name: '澳大利亚',
    code_name: 'AU',
    areaCode: '61',
    name_zhTW: '澳洲',
  },
  {
    country: 'United Kingdom',
    name: '英国',
    code_name: 'GB',
    areaCode: '44',
    name_zhTW: '英國',
  },
  {
    country: 'South Africa',
    name: '南非',
    code_name: 'ZA',
    areaCode: '27',
    name_zhTW: '南非',
  },
  {
    country: 'Andorra',
    name: '安道尔',
    code_name: 'AD',
    areaCode: '376',
    name_zhTW: '安道爾',
  },
  {
    country: 'Afghanistan',
    name: '阿富汗',
    code_name: 'AF',
    areaCode: '93',
    name_zhTW: '阿富汗',
  },
  {
    country: 'Antigua and   Barbuda',
    name: '安提瓜和巴布达',
    code_name: 'AG',
    areaCode: '1268',
    name_zhTW: '安提瓜和巴布達',
  },
  {
    country: 'Anguilla',
    name: '安圭拉',
    code_name: 'AI',
    areaCode: '1264',
    name_zhTW: '安圭拉',
  },
  {
    country: 'Albania',
    name: '阿尔巴尼亚',
    code_name: 'AL',
    areaCode: '355',
    name_zhTW: '阿爾巴尼亞',
  },
  {
    country: 'Armenia',
    name: '亚美尼亚',
    code_name: 'AM',
    areaCode: '374',
    name_zhTW: '亞美尼亞',
  },
  {
    country: 'Angola',
    name: '安哥拉',
    code_name: 'AO',
    areaCode: '244',
    name_zhTW: '安哥拉',
  },
  {
    country: 'Argentina',
    name: '阿根廷',
    code_name: 'AR',
    areaCode: '54',
    name_zhTW: '阿根廷',
  },
  {
    country: 'American   Samoa',
    name: '美属萨摩亚',
    code_name: 'AS',
    areaCode: '1684',
    name_zhTW: '美屬薩摩亞',
  },
  {
    country: 'Austria',
    name: '奥地利',
    code_name: 'AT',
    areaCode: '43',
    name_zhTW: '奧地利',
  },
  {
    country: 'Aruba',
    name: '阿鲁巴',
    code_name: 'AW',
    areaCode: '297',
    name_zhTW: '阿魯巴',
  },
  {
    country: 'Azerbaijan',
    name: '阿塞拜疆',
    code_name: 'AZ',
    areaCode: '994',
    name_zhTW: '阿塞拜疆',
  },
  {
    country: 'Bosniaand   Herzegovina',
    name: '波斯尼亚和黑塞哥维那',
    code_name: 'BA',
    areaCode: '387',
    name_zhTW: '波斯尼亞和黑塞哥維那',
  },
  {
    country: 'Barbados',
    name: '巴巴多斯',
    code_name: 'BB',
    areaCode: '1246',
    name_zhTW: '巴巴多斯',
  },
  {
    country: 'Bangladesh',
    name: '孟加拉国',
    code_name: 'BD',
    areaCode: '880',
    name_zhTW: '孟加拉',
  },
  {
    country: 'Belgium',
    name: '比利时',
    code_name: 'BE',
    areaCode: '32',
    name_zhTW: '比利時',
  },
  {
    country: 'Burkina Faso',
    name: '布基纳法索',
    code_name: 'BF',
    areaCode: '226',
    name_zhTW: '布基納法索',
  },
  {
    country: 'Bulgaria',
    name: '保加利亚',
    code_name: 'BG',
    areaCode: '359',
    name_zhTW: '保加利亞',
  },
  {
    country: 'Bahrain',
    name: '巴林',
    code_name: 'BH',
    areaCode: '973',
    name_zhTW: '巴林',
  },
  {
    country: 'Benin',
    name: '贝宁',
    code_name: 'BJ',
    areaCode: '229',
    name_zhTW: '貝寧',
  },
  {
    country: 'Bermuda',
    name: '百慕大群岛',
    code_name: 'BM',
    areaCode: '1441',
    name_zhTW: '百慕達',
  },
  {
    country: 'Brunei',
    name: '文莱',
    code_name: 'BN',
    areaCode: '673',
    name_zhTW: '汶萊',
  },
  {
    country: 'Bolivia',
    name: '玻利维亚',
    code_name: 'BO',
    areaCode: '591',
    name_zhTW: '玻利維亞',
  },
  {
    country: 'Caribisch   Nederland',
    name: '荷兰加勒比',
    code_name: 'BQ',
    areaCode: '599',
    name_zhTW: '荷屬安的列斯',
  },
  {
    country: 'Brazil',
    name: '巴西',
    code_name: 'BR',
    areaCode: '55',
    name_zhTW: '巴西',
  },
  {
    country: 'Bahamas',
    name: '巴哈马',
    code_name: 'BS',
    areaCode: '1242',
    name_zhTW: '巴哈馬',
  },
  {
    country: 'Bhutan',
    name: '不丹',
    code_name: 'BT',
    areaCode: '975',
    name_zhTW: '不丹',
  },
  {
    country: 'Botswana',
    name: '博茨瓦纳',
    code_name: 'BW',
    areaCode: '267',
    name_zhTW: '博茨瓦納',
  },
  {
    country: 'Belize',
    name: '伯利兹',
    code_name: 'BZ',
    areaCode: '501',
    name_zhTW: '伯利兹',
  },
  {
    country: 'Democratic   Republic of theCongo',
    name: '刚果民主共和国',
    code_name: 'CD',
    areaCode: '243',
    name_zhTW: '剛果（金夏沙）',
  },
  {
    country: 'Switzerland',
    name: '瑞士',
    code_name: 'CH',
    areaCode: '41',
    name_zhTW: '瑞士',
  },
  {
    country: 'Ivory Coast',
    name: '象牙海岸',
    code_name: 'CI',
    areaCode: '225',
    name_zhTW: '科特迪瓦',
  },
  {
    country: 'Cook Islands',
    name: '库克群岛',
    code_name: 'CK',
    areaCode: '682',
    name_zhTW: '庫克群島',
  },
  {
    country: 'Chile',
    name: '智利',
    code_name: 'CL',
    areaCode: '56',
    name_zhTW: '智利',
  },
  {
    country: 'Cameroon',
    name: '喀麦隆',
    code_name: 'CM',
    areaCode: '237',
    name_zhTW: '喀麥隆',
  },
  {
    country: 'Colombia',
    name: '哥伦比亚',
    code_name: 'CO',
    areaCode: '57',
    name_zhTW: '哥倫比亞',
  },
  {
    country: 'CostaRica',
    name: '哥斯达黎加',
    code_name: 'CR',
    areaCode: '506',
    name_zhTW: '哥斯達黎加',
  },
  {
    country: 'Cape Verde',
    name: '开普',
    code_name: 'CV',
    areaCode: '238',
    name_zhTW: '佛得角共和國',
  },
  {
    country: 'Curacao',
    name: '库拉索',
    code_name: 'CW',
    areaCode: '599',
    name_zhTW: '庫拉索',
  },
  {
    country: 'Cyprus',
    name: '塞浦路斯',
    code_name: 'CY',
    areaCode: '357',
    name_zhTW: '塞浦路斯共和國',
  },
  {
    country: 'Czech',
    name: '捷克',
    code_name: 'CZ',
    areaCode: '420',
    name_zhTW: '捷克',
  },
  {
    country: 'Germany',
    name: '德国',
    code_name: 'DE',
    areaCode: '49',
    name_zhTW: '德國',
  },
  {
    country: 'Djibouti',
    name: '吉布提',
    code_name: 'DJ',
    areaCode: '253',
    name_zhTW: '吉布提',
  },
  {
    country: 'Denmark',
    name: '丹麦',
    code_name: 'DK',
    areaCode: '45',
    name_zhTW: '丹麥',
  },
  {
    country: 'Dominica',
    name: '多米尼加',
    code_name: 'DM',
    areaCode: '1767',
    name_zhTW: '多米尼克國',
  },
  {
    country: 'dominican   republic',
    name: '多米尼加共和国',
    code_name: 'DO',
    areaCode: '1809',
    name_zhTW: '多米尼加共和國',
  },
  {
    country: 'Algeria',
    name: '阿尔及利亚',
    code_name: 'DZ',
    areaCode: '213',
    name_zhTW: '阿爾及利亞',
  },
  {
    country: 'Ecuador',
    name: '厄瓜多尔',
    code_name: 'EC',
    areaCode: '593',
    name_zhTW: '厄瓜多爾',
  },
  {
    country: 'Estonia',
    name: '爱沙尼亚',
    code_name: 'EE',
    areaCode: '372',
    name_zhTW: '愛沙尼亞',
  },
  {
    country: 'Egypt',
    name: '埃及',
    code_name: 'EG',
    areaCode: '20',
    name_zhTW: '埃及',
  },
  {
    country: 'Eritrea',
    name: '厄立特里亚',
    code_name: 'ER',
    areaCode: '291',
    name_zhTW: '厄立特里亞',
  },
  {
    country: 'Spain',
    name: '西班牙',
    code_name: 'ES',
    areaCode: '34',
    name_zhTW: '西班牙',
  },
  {
    country: 'Ethiopia',
    name: '埃塞俄比亚',
    code_name: 'ET',
    areaCode: '251',
    name_zhTW: '埃塞俄比亞',
  },
  {
    country: 'Finland',
    name: '芬兰',
    code_name: 'FI',
    areaCode: '358',
    name_zhTW: '芬蘭',
  },
  {
    country: 'Fiji',
    name: '斐济',
    code_name: 'FJ',
    areaCode: '679',
    name_zhTW: '斐濟',
  },
  {
    country: 'Micronesia',
    name: '密克罗尼西亚',
    code_name: 'FM',
    areaCode: '691',
    name_zhTW: '密克羅尼西亞',
  },
  {
    country: 'Faroe Islands',
    name: '法罗群岛',
    code_name: 'FO',
    areaCode: '298',
    name_zhTW: '法羅群島',
  },
  {
    country: 'France',
    name: '法国',
    code_name: 'FR',
    areaCode: '33',
    name_zhTW: '法國',
  },
  {
    country: 'Gabon',
    name: '加蓬',
    code_name: 'GA',
    areaCode: '241',
    name_zhTW: '加蓬',
  },
  {
    country: 'Grenada',
    name: '格林纳达',
    code_name: 'GD',
    areaCode: '1473',
    name_zhTW: '格林納達',
  },
  {
    country: 'Georgia',
    name: '格鲁吉亚',
    code_name: 'GE',
    areaCode: '995',
    name_zhTW: '格魯吉亞',
  },
  {
    country: 'French Guiana',
    name: '法属圭亚那',
    code_name: 'GF',
    areaCode: '594',
    name_zhTW: '法屬圭亞那',
  },
  {
    country: 'Ghana',
    name: '加纳',
    code_name: 'GH',
    areaCode: '233',
    name_zhTW: '加納',
  },
  {
    country: 'Gibraltar',
    name: '直布罗陀',
    code_name: 'GI',
    areaCode: '350',
    name_zhTW: '直布羅陀',
  },
  {
    country: 'Greenland',
    name: '格陵兰岛',
    code_name: 'GL',
    areaCode: '299',
    name_zhTW: '格陵蘭',
  },
  {
    country: 'Gambia',
    name: '冈比亚',
    code_name: 'GM',
    areaCode: '220',
    name_zhTW: '岡比亞',
  },
  {
    country: 'Guinea',
    name: '几内亚',
    code_name: 'GN',
    areaCode: '224',
    name_zhTW: '幾內亞',
  },
  {
    country: 'Guadeloupe',
    name: '瓜德罗普岛',
    code_name: 'GP',
    areaCode: '590',
    name_zhTW: '瓜德羅普',
  },
  {
    country: 'Equatorial   Guinea',
    name: '赤道几内亚',
    code_name: 'GQ',
    areaCode: '240',
    name_zhTW: '赤道幾內亞',
  },
  {
    country: 'Greece',
    name: '希腊',
    code_name: 'GR',
    areaCode: '30',
    name_zhTW: '希臘',
  },
  {
    country: 'Guatemala',
    name: '瓜地马拉',
    code_name: 'GT',
    areaCode: '502',
    name_zhTW: '危地馬拉',
  },
  {
    country: 'Guam',
    name: '关岛',
    code_name: 'GU',
    areaCode: '1671',
    name_zhTW: '關島',
  },
  {
    country: 'Guinea-Bissau',
    name: '几内亚比绍共和国',
    code_name: 'GW',
    areaCode: '245',
    name_zhTW: '幾內亞比紹',
  },
  {
    country: 'Guyana',
    name: '圭亚那',
    code_name: 'GY',
    areaCode: '592',
    name_zhTW: '圭亞那',
  },
  {
    country: 'Honduras',
    name: '洪都拉斯',
    code_name: 'HN',
    areaCode: '504',
    name_zhTW: '洪都拉斯',
  },
  {
    country: 'Croatia',
    name: '克罗地亚',
    code_name: 'HR',
    areaCode: '385',
    name_zhTW: '克羅地亞共和國',
  },
  {
    country: 'Haiti',
    name: '海地',
    code_name: 'HT',
    areaCode: '509',
    name_zhTW: '海地',
  },
  {
    country: 'Hungary',
    name: '匈牙利',
    code_name: 'HU',
    areaCode: '36',
    name_zhTW: '匈牙利',
  },
  {
    country: 'Indonesia',
    name: '印度尼西亚',
    code_name: 'ID',
    areaCode: '62',
    name_zhTW: '印尼',
  },
  {
    country: 'Ireland',
    name: '爱尔兰',
    code_name: 'IE',
    areaCode: '353',
    name_zhTW: '愛爾蘭',
  },
  {
    country: 'Israel',
    name: '以色列',
    code_name: 'IL',
    areaCode: '972',
    name_zhTW: '以色列',
  },
  {
    country: 'India',
    name: '印度',
    code_name: 'IN',
    areaCode: '91',
    name_zhTW: '印度',
  },
  {
    country: 'Iceland',
    name: '冰岛',
    code_name: 'IS',
    areaCode: '354',
    name_zhTW: '冰島',
  },
  {
    country: 'Italy',
    name: '意大利',
    code_name: 'IT',
    areaCode: '39',
    name_zhTW: '意大利',
  },
  {
    country: 'Jamaica',
    name: '牙买加',
    code_name: 'JM',
    areaCode: '1876',
    name_zhTW: '牙買加',
  },
  {
    country: 'Jordan',
    name: '约旦',
    code_name: 'JO',
    areaCode: '962',
    name_zhTW: '約旦',
  },
  {
    country: 'Japan',
    name: '日本',
    code_name: 'JP',
    areaCode: '81',
    name_zhTW: '日本',
  },
  {
    country: 'Kenya',
    name: '肯尼亚',
    code_name: 'KE',
    areaCode: '254',
    name_zhTW: '肯雅',
  },
  {
    country: 'Kyrgyzstan',
    name: '吉尔吉斯斯坦',
    code_name: 'KG',
    areaCode: '996',
    name_zhTW: '吉爾吉斯',
  },
  {
    country: 'Cambodia',
    name: '柬埔寨',
    code_name: 'KH',
    areaCode: '855',
    name_zhTW: '柬埔寨',
  },
  {
    country: 'Kiribati',
    name: '基里巴斯',
    code_name: 'KI',
    areaCode: '686',
    name_zhTW: '基里巴斯',
  },
  {
    country: 'Comoros',
    name: '科摩罗',
    code_name: 'KM',
    areaCode: '269',
    name_zhTW: '科摩羅',
  },
  {
    country: 'Saint Kitts   and Nevis',
    name: '圣基茨和尼维斯',
    code_name: 'KN',
    areaCode: '1869',
    name_zhTW: '聖基茨和尼維斯',
  },
  {
    country: 'South Korea',
    name: '韩国',
    code_name: 'KR',
    areaCode: '82',
    name_zhTW: '南韓',
  },
  {
    country: 'Kuwait',
    name: '科威特',
    code_name: 'KW',
    areaCode: '965',
    name_zhTW: '科威特',
  },
  {
    country: 'Cayman   Islands',
    name: '开曼群岛',
    code_name: 'KY',
    areaCode: '1345',
    name_zhTW: '開曼群島',
  },
  {
    country: 'Kazakhstan',
    name: '哈萨克斯坦',
    code_name: 'KZ',
    areaCode: '7',
    name_zhTW: '哈薩克',
  },
  {
    country: 'Laos',
    name: '老挝',
    code_name: 'LA',
    areaCode: '856',
    name_zhTW: '老撾',
  },
  {
    country: 'Saint Lucia',
    name: '圣露西亚',
    code_name: 'LC',
    areaCode: '1758',
    name_zhTW: '聖盧西亞',
  },
  {
    country: 'Liechtenstein',
    name: '列支敦士登',
    code_name: 'LI',
    areaCode: '423',
    name_zhTW: '列支敦士登',
  },
  {
    country: 'Sri Lanka',
    name: '斯里兰卡',
    code_name: 'LK',
    areaCode: '94',
    name_zhTW: '斯里蘭卡',
  },
  {
    country: 'Liberia',
    name: '利比里亚',
    code_name: 'LR',
    areaCode: '231',
    name_zhTW: '利比里亞',
  },
  {
    country: 'Lesotho',
    name: '莱索托',
    code_name: 'LS',
    areaCode: '266',
    name_zhTW: '莱索托',
  },
  {
    country: 'Lithuania',
    name: '立陶宛',
    code_name: 'LT',
    areaCode: '370',
    name_zhTW: '立陶宛',
  },
  {
    country: 'Luxembourg',
    name: '卢森堡',
    code_name: 'LU',
    areaCode: '352',
    name_zhTW: '盧森堡',
  },
  {
    country: 'Latvia',
    name: '拉脱维亚',
    code_name: 'LV',
    areaCode: '371',
    name_zhTW: '拉脫維亞',
  },
  {
    country: 'Morocco',
    name: '摩洛哥',
    code_name: 'MA',
    areaCode: '212',
    name_zhTW: '摩洛哥',
  },
  {
    country: 'Monaco',
    name: '摩纳哥',
    code_name: 'MC',
    areaCode: '377',
    name_zhTW: '摩納哥',
  },
  {
    country: 'Moldova',
    name: '摩尔多瓦',
    code_name: 'MD',
    areaCode: '373',
    name_zhTW: '摩爾多瓦',
  },
  {
    country: 'Montenegro',
    name: '黑山',
    code_name: 'ME',
    areaCode: '382',
    name_zhTW: '黑山',
  },
  {
    country: 'Madagascar',
    name: '马达加斯加',
    code_name: 'MG',
    areaCode: '261',
    name_zhTW: '馬達加斯加',
  },
  {
    country: 'Marshall   Islands',
    name: '马绍尔群岛',
    code_name: 'MH',
    areaCode: '692',
    name_zhTW: '馬紹爾群島',
  },
  {
    country: 'Macedonia',
    name: '马其顿',
    code_name: 'MK',
    areaCode: '389',
    name_zhTW: '北馬其頓共和國',
  },
  {
    country: 'Myanmar',
    name: '缅甸',
    code_name: 'MM',
    areaCode: '95',
    name_zhTW: '緬甸',
  },
  {
    country: 'Mongolia',
    name: '蒙古',
    code_name: 'MN',
    areaCode: '976',
    name_zhTW: '蒙古',
  },
  {
    country: 'Macau (China)',
    name: '中国澳门',
    code_name: 'MO',
    areaCode: '853',
    name_zhTW: '中國澳門',
  },
  {
    country: 'Mauritania',
    name: '毛里塔尼亚',
    code_name: 'MR',
    areaCode: '222',
    name_zhTW: '毛里塔尼亞',
  },
  {
    country: 'Montserrat',
    name: '蒙特塞拉特岛',
    code_name: 'MS',
    areaCode: '1664',
    name_zhTW: '蒙特塞拉特島',
  },
  {
    country: 'Malta',
    name: '马耳他',
    code_name: 'MT',
    areaCode: '356',
    name_zhTW: '馬耳他',
  },
  {
    country: 'Mauritius',
    name: '毛里求斯',
    code_name: 'MU',
    areaCode: '230',
    name_zhTW: '毛里裘斯',
  },
  {
    country: 'Maldives',
    name: '马尔代夫',
    code_name: 'MV',
    areaCode: '960',
    name_zhTW: '馬爾代夫',
  },
  {
    country: 'Malawi',
    name: '马拉维',
    code_name: 'MW',
    areaCode: '265',
    name_zhTW: '馬拉維',
  },
  {
    country: 'Mexico',
    name: '墨西哥',
    code_name: 'MX',
    areaCode: '52',
    name_zhTW: '墨西哥',
  },
  {
    country: 'Malaysia',
    name: '马来西亚',
    code_name: 'MY',
    areaCode: '60',
    name_zhTW: '馬來西亞',
  },
  {
    country: 'Mozambique',
    name: '莫桑比克',
    code_name: 'MZ',
    areaCode: '258',
    name_zhTW: '莫桑比克',
  },
  {
    country: 'Namibia',
    name: '纳米比亚',
    code_name: 'NA',
    areaCode: '264',
    name_zhTW: '納米比亞',
  },
  {
    country: 'New Caledonia',
    name: '新喀里多尼亚',
    code_name: 'NC',
    areaCode: '687',
    name_zhTW: '新喀里多尼亞',
  },
  {
    country: 'Niger',
    name: '尼日尔',
    code_name: 'NE',
    areaCode: '227',
    name_zhTW: '尼日爾',
  },
  {
    country: 'Nigeria',
    name: '尼日利亚',
    code_name: 'NG',
    areaCode: '234',
    name_zhTW: '尼日利亞',
  },
  {
    country: 'Netherlands',
    name: '荷兰',
    code_name: 'NL',
    areaCode: '31',
    name_zhTW: '荷蘭',
  },
  {
    country: 'Norway',
    name: '挪威',
    code_name: 'NO',
    areaCode: '47',
    name_zhTW: '挪威',
  },
  {
    country: 'Nepal',
    name: '尼泊尔',
    code_name: 'NP',
    areaCode: '977',
    name_zhTW: '尼泊爾',
  },
  {
    country: 'Nauru',
    name: '拿鲁岛',
    code_name: 'NR',
    areaCode: '674',
    name_zhTW: '瑙魯',
  },
  {
    country: 'New Zealand',
    name: '新西兰',
    code_name: 'NZ',
    areaCode: '64',
    name_zhTW: '紐西蘭',
  },
  {
    country: 'Oman',
    name: '阿曼',
    code_name: 'OM',
    areaCode: '968',
    name_zhTW: '阿曼',
  },
  {
    country: 'Panama',
    name: '巴拿马',
    code_name: 'PA',
    areaCode: '507',
    name_zhTW: '巴拿馬',
  },
  {
    country: 'Peru',
    name: '秘鲁',
    code_name: 'PE',
    areaCode: '51',
    name_zhTW: '秘魯',
  },
  {
    country: 'French   Polynesia',
    name: '法属波利尼西亚',
    code_name: 'PF',
    areaCode: '689',
    name_zhTW: '法屬玻利尼西亞',
  },
  {
    country: 'Papua New   Guinea',
    name: '巴布亚新几内亚',
    code_name: 'PG',
    areaCode: '675',
    name_zhTW: '巴布亞新畿內亞',
  },
  {
    country: 'Philippines',
    name: '菲律宾',
    code_name: 'PH',
    areaCode: '63',
    name_zhTW: '菲律賓',
  },
  {
    country: 'Pakistan',
    name: '巴基斯坦',
    code_name: 'PK',
    areaCode: '92',
    name_zhTW: '巴基斯坦',
  },
  {
    country: 'Poland',
    name: '波兰',
    code_name: 'PL',
    areaCode: '48',
    name_zhTW: '波蘭',
  },
  {
    country: 'Saint   Pierreand Miquelon',
    name: '圣彼埃尔和密克隆岛',
    code_name: 'PM',
    areaCode: '508',
    name_zhTW: '聖皮埃爾島及密克隆島',
  },
  {
    country: 'Puerto Rico',
    name: '波多黎各',
    code_name: 'PR',
    areaCode: '1787',
    name_zhTW: '波多黎各',
  },
  {
    country: 'Portugal',
    name: '葡萄牙',
    code_name: 'PT',
    areaCode: '351',
    name_zhTW: '葡萄牙',
  },
  {
    country: 'Palau',
    name: '帕劳',
    code_name: 'PW',
    areaCode: '680',
    name_zhTW: '帛琉',
  },
  {
    country: 'Paraguay',
    name: '巴拉圭',
    code_name: 'PY',
    areaCode: '595',
    name_zhTW: '巴拉圭',
  },
  {
    country: 'Qatar',
    name: '卡塔尔',
    code_name: 'QA',
    areaCode: '974',
    name_zhTW: '卡塔爾',
  },
  {
    country: 'Réunion   Island',
    name: '留尼汪',
    code_name: 'RE',
    areaCode: '262',
    name_zhTW: '留尼旺',
  },
  {
    country: 'Romania',
    name: '罗马尼亚',
    code_name: 'RO',
    areaCode: '40',
    name_zhTW: '羅馬尼亞',
  },
  {
    country: 'Serbia',
    name: '塞尔维亚',
    code_name: 'RS',
    areaCode: '381',
    name_zhTW: '塞爾維亞',
  },
  {
    country: 'Russia',
    name: '俄罗斯',
    code_name: 'RU',
    areaCode: '7',
    name_zhTW: '俄羅斯',
  },
  {
    country: 'Rwanda',
    name: '卢旺达',
    code_name: 'RW',
    areaCode: '250',
    name_zhTW: '盧旺達',
  },
  {
    country: 'Saudi Arabia',
    name: '沙特阿拉伯',
    code_name: 'SA',
    areaCode: '966',
    name_zhTW: '沙特阿拉伯',
  },
  {
    country: 'Solomon   Islands',
    name: '所罗门群岛',
    code_name: 'SB',
    areaCode: '677',
    name_zhTW: '所羅門群島',
  },
  {
    country: 'Seychelles',
    name: '塞舌尔',
    code_name: 'SC',
    areaCode: '248',
    name_zhTW: '塞舌爾',
  },
  {
    country: 'Sudan',
    name: '苏丹',
    code_name: 'SD',
    areaCode: '249',
    name_zhTW: '蘇丹',
  },
  {
    country: 'Sweden',
    name: '瑞典',
    code_name: 'SE',
    areaCode: '46',
    name_zhTW: '瑞典',
  },
  {
    country: 'Slovenia',
    name: '斯洛文尼亚',
    code_name: 'SI',
    areaCode: '386',
    name_zhTW: '斯洛文尼亞共和國',
  },
  {
    country: 'Slovakia',
    name: '斯洛伐克',
    code_name: 'SK',
    areaCode: '421',
    name_zhTW: '斯洛伐克',
  },
  {
    country: 'Sierra Leone',
    name: '塞拉利昂',
    code_name: 'SL',
    areaCode: '232',
    name_zhTW: '塞拉利昂',
  },
  {
    country: 'San Marino',
    name: '圣马力诺',
    code_name: 'SM',
    areaCode: '378',
    name_zhTW: '聖馬利諾',
  },
  {
    country: 'Senegal',
    name: '塞内加尔',
    code_name: 'SN',
    areaCode: '221',
    name_zhTW: '塞內加爾',
  },
  {
    country: 'Suriname',
    name: '苏里南',
    code_name: 'SR',
    areaCode: '597',
    name_zhTW: '蘇里南',
  },
  {
    country: 'Sao Tome and   Principe',
    name: '圣多美和普林西比',
    code_name: 'ST',
    areaCode: '239',
    name_zhTW: '聖多美和普林西比',
  },
  {
    country: 'ElSalvador',
    name: '萨尔瓦多',
    code_name: 'SV',
    areaCode: '503',
    name_zhTW: '薩爾瓦多',
  },
  {
    country: 'Swaziland',
    name: '斯威士兰',
    code_name: 'SZ',
    areaCode: '268',
    name_zhTW: '斯威士蘭',
  },
  {
    country: 'Turksand   Caicos Islands',
    name: '特克斯和凯科斯群岛',
    code_name: 'TC',
    areaCode: '1649',
    name_zhTW: '特克斯和凱科斯群島',
  },
  {
    country: 'Chad',
    name: '乍得',
    code_name: 'TD',
    areaCode: '235',
    name_zhTW: '乍得',
  },
  {
    country: 'Togo',
    name: '多哥',
    code_name: 'TG',
    areaCode: '228',
    name_zhTW: '多哥',
  },
  {
    country: 'Thailand',
    name: '泰国',
    code_name: 'TH',
    areaCode: '66',
    name_zhTW: '泰國',
  },
  {
    country: 'Tajikistan',
    name: '塔吉克斯坦',
    code_name: 'TJ',
    areaCode: '992',
    name_zhTW: '塔吉克',
  },
  {
    country: 'East Timor',
    name: '东帝汶',
    code_name: 'TL',
    areaCode: '670',
    name_zhTW: '東帝汶',
  },
  {
    country: 'Turkmenistan',
    name: '土库曼斯坦',
    code_name: 'TM',
    areaCode: '993',
    name_zhTW: '土庫曼',
  },
  {
    country: 'Tunisia',
    name: '突尼斯',
    code_name: 'TN',
    areaCode: '216',
    name_zhTW: '突尼西亞',
  },
  {
    country: 'Tonga',
    name: '汤加',
    code_name: 'TO',
    areaCode: '676',
    name_zhTW: '湯加王國',
  },
  {
    country: 'Turkey',
    name: '土耳其',
    code_name: 'TR',
    areaCode: '90',
    name_zhTW: '土耳其',
  },
  {
    country: 'Trinidadand   Tobago',
    name: '特立尼达和多巴哥',
    code_name: 'TT',
    areaCode: '1868',
    name_zhTW: '千里達及托巴哥',
  },
  {
    country: 'Taiwan (China)',
    name: '中国台湾',
    code_name: 'TW',
    areaCode: '886',
    name_zhTW: '中國台灣',
  },
  {
    country: 'Tanzania',
    name: '坦桑尼亚',
    code_name: 'TZ',
    areaCode: '255',
    name_zhTW: '坦桑尼亞',
  },
  {
    country: 'Uganda',
    name: '乌干达',
    code_name: 'UG',
    areaCode: '256',
    name_zhTW: '烏干達',
  },
  {
    country: 'Uruguay',
    name: '乌拉圭',
    code_name: 'UY',
    areaCode: '598',
    name_zhTW: '烏拉圭',
  },
  {
    country: 'Uzbekistan',
    name: '乌兹别克斯坦',
    code_name: 'UZ',
    areaCode: '998',
    name_zhTW: '烏茲別克',
  },
  {
    country: 'Saint Vincent   and The Grenadines',
    name: '圣文森特和格林纳丁斯',
    code_name: 'VC',
    areaCode: '1784',
    name_zhTW: '聖文森特和格林納丁斯',
  },
  {
    country: 'VirginIslands,British',
    name: '英属处女群岛',
    code_name: 'VG',
    areaCode: '1284',
    name_zhTW: '英屬維爾京群島',
  },
  {
    country: 'Vietnam',
    name: '越南',
    code_name: 'VN',
    areaCode: '84',
    name_zhTW: '越南',
  },
  {
    country: 'Vanuatu',
    name: '瓦努阿图',
    code_name: 'VU',
    areaCode: '678',
    name_zhTW: '瓦努阿圖',
  },
  {
    country: 'Samoa',
    name: '萨摩亚',
    code_name: 'WS',
    areaCode: '685',
    name_zhTW: '薩摩亞',
  },
  {
    country: 'Mayotte',
    name: '马约特',
    code_name: 'YT',
    areaCode: '269',
    name_zhTW: '科摩羅',
  },
  {
    country: 'Zambia',
    name: '赞比亚',
    code_name: 'ZM',
    areaCode: '260',
    name_zhTW: '贊比亞共和國',
  },
];
